var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.033f92f94f8b458e94021b094e69ec63.svg#L';
                    var viewUrl = 'sprites.033f92f94f8b458e94021b094e69ec63.svg#view-L';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 30 30',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };